import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = [
    "input",
    "preview",
    "placeholder",
    "signedId",
    "remove",
    "removeButton",
    "error",
  ]
  static values = {
    uploadUrl: String,
    maxSize: Number,
    types: Array,
    invalidTypeMessage: String,
    tooLargeMessage: String,
    failedMessage: String,
  }

  disconnect() {
    this.revokePreview()
  }

  choose() {
    this.inputTarget.click()
  }

  pick() {
    const file = this.inputTarget.files[0]
    if (!file) return

    if (!this.typesValue.includes(file.type)) {
      this.inputTarget.value = ""
      return this.showError(this.invalidTypeMessageValue)
    }
    if (file.size > this.maxSizeValue) {
      this.inputTarget.value = ""
      return this.showError(this.tooLargeMessageValue)
    }

    this.showError(null)
    this.pendingFile = file
    this.signedIdTarget.value = ""
    this.removeTarget.value = "false"
    this.revokePreview()
    this.objectUrl = URL.createObjectURL(file)
    this.showPreview(this.objectUrl)
  }

  clear() {
    this.pendingFile = null
    this.inputTarget.value = ""
    this.signedIdTarget.value = ""
    this.removeTarget.value = "true"
    this.revokePreview()
    this.showPreview(null)
    this.showError(null)
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }

  async upload(event) {
    if (event.defaultPrevented || !this.pendingFile) return

    event.preventDefault()
    const submitter = event.submitter
    const body = new FormData()
    body.append("file", this.pendingFile)

    const response = await post(this.uploadUrlValue, {
      body,
      responseKind: "json",
    })
    if (!response.ok) return this.showError(this.failedMessageValue)

    const { signed_id: signedId } = await response.json
    this.signedIdTarget.value = signedId
    this.pendingFile = null
    this.inputTarget.value = ""
    this.element.requestSubmit(submitter)
  }

  showPreview(url) {
    this.previewTarget.classList.toggle("hidden", !url)
    this.placeholderTarget.classList.toggle("hidden", Boolean(url))
    this.removeButtonTarget.classList.toggle("hidden!", !url)
    if (url) this.previewTarget.src = url
    else this.previewTarget.removeAttribute("src")
  }

  showError(message) {
    this.errorTarget.textContent = message ?? ""
    this.errorTarget.classList.toggle("hidden", !message)
  }

  revokePreview() {
    if (this.objectUrl) URL.revokeObjectURL(this.objectUrl)
    this.objectUrl = null
  }
}
